// src/About.js
import React from "react";
import { Container, Typography } from "@mui/material";

function About() {
  return (
    <Container sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom>
        Toruko Hakkında
      </Typography>
      <Typography variant="body1" paragraph>
        Toruko, anime tutkunları için özel olarak tasarlanmış bir
        platformdur. Uygulamamız sayesinde en yeni anime bölümlerini izleyebilir
        ve kişiselleştirilmiş önerilerle anime keyfinizi en üst düzeye
        çıkarabilirsiniz.
      </Typography>
      <Typography variant="body1" paragraph>
        Reklam, telif hakları, soru ve öneriler ile ilgili konularda{" "}
        <a href="mailto:support@korsananime.com">support@korsananime.com</a>{" "}
        adresinden bizimle irtibat kurabilirsiniz.
      </Typography>
      <Typography variant="body1" paragraph>
        Toruko, 5651 sayılı yasanın 5. maddesinde tanımlanan yer
        sağlayıcı olarak hizmet vermektedir. İlgili yasaya göre, platform
        yönetimi hukuka aykırı içerikleri kontrol etme yükümlülüğüne sahip
        değildir. Bu sebeple, Toruko "uyar ve kaldır" prensibini
        benimsemiştir. Telif hakkına konu olan eserlerin yasal olmayan bir
        biçimde paylaşıldığını ve yasal haklarının ihlal edildiğini düşünen hak
        sahipleri veya meslek birlikleri,{" "}
        <a href="mailto:support@korsananime.com">support@korsananime.com</a>{" "}
        mail adresinden bize ulaşabilirler. Gelen talepler hukuki olarak
        incelenip, ihlal tespit edildiği takdirde, içerik platformumuzdan
        kaldırılacaktır.
      </Typography>

      <Typography variant="h6" gutterBottom>
        İlgili Yasa:
      </Typography>
      <Typography variant="body2" paragraph>
        <strong>MADDE 5-</strong>
        <br />
        (1) Yer sağlayıcı, sağladığı içeriği kontrol etmek veya hukuka aykırı bir
        faaliyetin söz konusu olup olmadığını araştırmakla yükümlü değildir.
        <br />
        (2) Yer sağlayıcı, hukuka aykırı içerikten, ceza sorumluluğu ile ilgili
        hükümler saklı kalmak kaydıyla, bu Kanunun 8. ve 9. maddelerine göre
        haberdar edilmesi halinde ve teknik olarak imkân bulunduğu ölçüde, hukuka
        aykırı içeriği yayından kaldırmakla yükümlüdür.
      </Typography>

      <Typography variant="body1">
        <em>
          English Translation: All videos featured in our application are
          aggregated from general video sources such as vk.com, mail.ru, etc. For
          productions whose copyright belongs to you, as long as you notify us at{" "}
          <a href="mailto:support@korsananime.com">support@korsananime.com</a>,
          we will remove the relevant production within 3 business days from our
          platform.
        </em>
      </Typography>
    </Container>
  );
}

export default About;
